import _ from 'lodash';

import { PAYMENT_METHOD_SETTINGS_RESPONSE_KEYS_MAP, PaymentMethodSettingsResponseKeys } from '../constants';
import { PaymentMethodSetting, PaymentMethodSettingsResponseItem } from '../entities';

export const getPaymentMethodSettingsTransformedData = (
    settings: PaymentMethodSettingsResponseItem[]
): PaymentMethodSetting[] => {
    const transformedData = [] as PaymentMethodSetting[];

    settings.forEach((paymentMethodSetting) => {
        paymentMethodSetting.roleSettings.forEach((roleSetting) => {
            const result = {
                paymentMethodId: paymentMethodSetting.paymentMethodId,
                role: roleSetting.role
            } as PaymentMethodSetting;

            roleSetting.settings.forEach((setting) => {
                const key = _.last(setting?.code?.split('.') ?? []) as PaymentMethodSettingsResponseKeys;

                result[PAYMENT_METHOD_SETTINGS_RESPONSE_KEYS_MAP[key]] = setting.value;
            });

            transformedData.push(result);
        });
    });

    return transformedData;
};
